export default {
  name: 'oz-sort',

  props: {
    options: { type: Array, required: true },
    sort: { type: String, default: '' },
  },

  data () {
    return {
      model: 'undefined',
      label: 'Ordenar por',
      currentLabel: 'Ordenar por',
    }
  },

  created () {
    if (this.sort !== '') {
      const objIndex2 = this.options.findIndex(((obj) => obj.value === this.sort))
      this.currentLabel = this.options[objIndex2].label
    }

    this.model = this.getModel(this.sort)
  },

  methods: {
    onSelectChange ({ label, value }) {
      this.currentLabel = label
      const localValue = value === 'undefined' ? undefined : value
      this.$emit('sort:change', localValue)
    },

    getModel (value) {
      if (!value || value === 'undefined') return 'undefined'
      const item = this.options.find((option) => option.value && option.value === value)
      return (item && item.value) || 'undefined'
    },
  },
}
